import { ViewContainerRef } from '@angular/core';

export enum NotificationPosition {
  TopLeft,
  Top,
  TopRight,
  BottomLeft,
  Bottom,
  BottomRight,
  Default = BottomRight,
}

export enum NotificationStyle {
  Success = 'success',
  Error = 'error',
  InProgress = 'inProgress',
  Timeout = 'timeout',
  Default = Success,
}

export class NotificationConfig {
  public timeout?: number = 5000;
  public showClose?: boolean = true;
  public groupIdentifier?: string;
  public viewContainerRef?: ViewContainerRef;
  public position?: NotificationPosition = NotificationPosition.Default;
  public style?: NotificationStyle = NotificationStyle.Default;
  public charactersCount?: number;
}
